/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from 'react';

import NomineeForm from './components';

const NomineeDetails = ({onSubmit, isLoading, isDisabled, schema, onSkip, isSkipLoading}) => (
  <NomineeForm
    onSubmit={onSubmit}
    isLoading={isLoading}
    isDisabled={isDisabled}
    schema={schema}
    onSkip={onSkip}
    isSkipLoading={isSkipLoading}
  />
);

export default NomineeDetails;
